import React, { useEffect } from 'react';
import { GIButton, Modal } from 'app-components';
import { addNote } from '../../../actions/account-activity/accountActivityActionCreators';
import { StyledModalButtonFooter, StyledTextArea } from './AccountActivity.styled';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { useAppDispatch } from '../../../hooks';
import { ADD_A_NOTE, NOTE_TYPES } from './common/accountActivity.constants';

interface IAddCallNoteModalProps {
    id: string | null;
    type: NOTE_TYPES;
    onClose: () => void;
    isOpen: boolean;
    refetchComments?: () => void;
}

const AddCallNoteModal = ({ id = '', type, onClose, isOpen, refetchComments }: IAddCallNoteModalProps) => {
    const [notes, setNotes] = React.useState('');
    const dispatch = useAppDispatch();

    // Define a mapping object to associate NOTE_TYPES with data properties
    const noteTypeData = {
        [NOTE_TYPES.CALL]: {
            id: 'add_call_note_modal',
            titleId: 'member.account.activity.note.modal.call.title',
        },
        [NOTE_TYPES.CHAT]: {
            id: 'add_chat_note_modal',
            titleId: 'member.account.activity.note.modal.chat.title',
        },
    };

    // Access the data using the type
    const data = noteTypeData[type] || {
        id: 'default_id',
        titleId: 'default_title',
    };

    useEffect(() => {
        if (!isOpen) setNotes('');
    }, [isOpen]);

    const onSave = () => {
        if (!id) return;
        const payload = new FormData();
        if (type === NOTE_TYPES.CALL) {
            payload.append('notes', notes);
        } else {
            payload.append('chatnotes', notes);
        }
        payload.append('csrftoken', window.csrf_token);

        dispatch(
            addNote(
                {
                    id,
                    payload,
                    type: NOTE_TYPES[type],
                },
                () => {
                    refetchComments && refetchComments();
                    onClose();
                },
            ),
        );
    };

    return (
        <ConditionalRendering isTrue={isOpen}>
            <Modal id={data.id}>
                <Modal.Header id="modal_header" titleId={data.titleId} onHide={onClose} />
                <Modal.Body>
                    <div>
                        <StyledTextArea
                            data-testid="notes"
                            rows={9}
                            cols={40}
                            maxLength={ADD_A_NOTE.MAX_NOTE_LENGTH}
                            spellCheck="true"
                            name="notes"
                            id="notes"
                            value={notes}
                            onChange={e => setNotes(e.target.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Controls>
                    <StyledModalButtonFooter>
                        <GIButton
                            id="cancel_btn"
                            labelId="button.cancel"
                            variant="secondary"
                            onClickHandler={onClose}
                        />
                        <GIButton
                            id="continue_btn"
                            labelId="member.account.activity.note.modal.save"
                            onClickHandler={() => {
                                onSave();
                            }}
                            isDisabled={!notes}
                        />
                    </StyledModalButtonFooter>
                </Modal.Controls>
            </Modal>
        </ConditionalRendering>
    );
};

export default AddCallNoteModal;
